/* eslint-disable func-names, max-len, no-underscore-dangle */
import 'slick-carousel';

$('.js-carousel-top').slick({
  lazyLoad: 'ondemand',
  lazyLoadBuffer: 1,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: true,
  dots: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'ease',
  arrows: true,
  responsive: [{
    breakpoint: 768,
    settings: {
      centerMode: true,
      slidesToShow: 2,
    },
  }, {
    breakpoint: 480,
    settings: {
      centerMode: true,
      slidesToShow: 1,
    },
  }],
});

const $prodCarousel = $('.js-prod-carousel');
let automaticCarousel = false;

if ($prodCarousel.length && $prodCarousel.data('automatic-mode') === 'True') {
  automaticCarousel = true;
}

if ($('.js-prod-carousel .prod-carousel__slide').length >= 4) {
  $prodCarousel.slick({
    lazyLoad: 'ondemand',
    lazyLoadBuffer: 1,
    centerMode: true,
    centerPadding: '100px',
    slidesToShow: 3,
    autoplay: automaticCarousel,
    autoplaySpeed: 1000,
    speed: 1000,
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '20px',
          slidesToShow: 1,
        },
      },
    ],
  });
} else {
  $prodCarousel.addClass('low-amount');
}
